import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import ImageHelper from '../../Helpers/ImageHelper';
const Error500 = () => {

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        p: 4,
    }



    return (
        <div>

            <Header />
            <Box sx={{ position: 'relative', height: "500px" }}>
                <Box sx={style}>
                    {/* <Header isSignedIn={isSignedIn} userName={userName} /> */}
                    <Typography variant="h5" component="h2" >
                        <img src={ImageHelper.erimage} alt='err' />
                        Error 500:<br /> the server encountered an unexpected condition that prevented it from fulfilling the request.
                    </Typography>
                </Box>
            </Box>
            <Footer />
        </div>
    )
}

export default Error500;